'use es6';

export const getWebsiteGrade = state => state.grader;
export const getDomain = state => getWebsiteGrade(state).domain;